/* eslint-disable no-use-before-define */
import kindOf from './kindOf';

const { valueOf } = Symbol.prototype;

function cloneRegExp(val: any) {
  const flags = val.flags !== undefined ? val.flags : (/\w+$/.exec(val) || undefined);
  const re = new val.constructor(val.source, flags);
  re.lastIndex = val.lastIndex;
  return re;
}

function cloneArrayBuffer(val: any) {
  const res = new val.constructor(val.byteLength);
  new Uint8Array(res).set(new Uint8Array(val));
  return res;
}

function cloneTypedArray(val: any) {
  return new val.constructor(val.buffer, val.byteOffset, val.length);
}

function cloneBuffer(val: any) {
  // eslint-disable-next-line no-console
  console.warn('Buffer detected during deepClone, Buffers are copied by reference!');
  // const len = val.length;
  // if (Buffer) {
  //   const buf = Buffer.allocUnsafe ? Buffer.allocUnsafe(len) : Buffer.from(len);
  //   val.copy(buf);
  //   return buf;
  // }
  return val;
}

function cloneSymbol(val: any) {
  return valueOf ? Object(valueOf.call(val)) : {};
}

function clone(val: any) {
  const type = kindOf(val);
  switch (type) {
    case 'array':
      return val.slice();
    case 'object':
      return { ...val };
    case 'date':
      return new val.constructor(Number(val));
    case 'map':
      return new Map(val);
    case 'set':
      return new Set(val);
    case 'buffer':
      return cloneBuffer(val);
    case 'symbol':
      return cloneSymbol(val);
    case 'arraybuffer':
      return cloneArrayBuffer(val);
    case 'float32array':
    case 'float64array':
    case 'int16array':
    case 'int32array':
    case 'int8array':
    case 'uint16array':
    case 'uint32array':
    case 'uint8clampedarray':
    case 'uint8array':
      return cloneTypedArray(val);
    case 'regexp':
      return cloneRegExp(val);
    case 'error':
      return Object.create(val);
    default: {
      return val;
    }
  }
}

function cloneObjectDeep(from: any) {
  const to = new from.constructor();
  // eslint-disable-next-line no-restricted-syntax, guard-for-in
  for (const key in from) {
    const toDescriptor = Object.getOwnPropertyDescriptor(to, key);
    const canWriteTo = !toDescriptor || toDescriptor.writable || toDescriptor.set;
    if (canWriteTo) {
      if (typeof from[key] === 'function') {
        to[key] = from[key].bind(to);
      } else {
        to[key] = deepClone(from[key]);
      }
    }
  }
  return to;
}

export default function deepClone<T>(val: T): T {
  switch (kindOf(val)) {
    case 'object':
      return cloneObjectDeep(val);
    case 'array':
      return cloneArrayDeep(val);
    default: {
      return clone(val);
    }
  }
}

function cloneArrayDeep(val: any) {
  const res = new val.constructor(val.length);
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < val.length; i++) {
    res[i] = deepClone(val[i]);
  }
  return res;
}
